import { Navigator } from '../components/Navigator/index.jsx';
import { useTranslation } from 'react-i18next';

const NavigatorPage = () => {
  const { t } = useTranslation();

   return (
     <>
       <main className="main">
         <Navigator t={t}/>
       </main>
     </>
   );
 }

 export default NavigatorPage;